import { Button, IconArrowRight } from '@veneer/core';
import React from 'react';
import { authenticationService } from '../../services/context/AuthService';

const InvalidIdentityProvider = () => {

    return (
        <>
            <h4>HP Employees must login using the HP Enterprise Directory instead of HP ID's local accounts, please login again.</h4>
            <Button
                style={{ marginTop: '16px' }}
                onClick={() => authenticationService.logout()}
                trailingIcon={<IconArrowRight />}
            >
                Go to login again
            </Button>
        </>
    );
}

export default InvalidIdentityProvider;